import { ApiCommonParams, ResponseWithError } from '../models/app';
import { IProfileOrder } from '../models/profile';
import { getAPIClient } from '@/lib/api';

export const requestGuestReturn = async ({
  lang,
  country,
  token,
  id_order,
  email,
  message
}: ApiCommonParams & {
  id_order: string;
  email: string;
  message: string;
}): Promise<ResponseWithError> => {
  const apiClient = getAPIClient({ country });

  return await apiClient.post(
    '/wp-json/uyn/v1/user/guest/return',
    { id_order, email, message },
    {
      headers: {
        ['UYN-BEARER']: token,
        ['UYN-LANGUAGE']: lang,
        ['UYN-COUNTRY']: country
      }
    }
  );
};

interface GuestOrderResponse {
  order: IProfileOrder | IProfileOrder[];
}

export const getGuestOrder = async ({
  lang,
  country,
  token,
  id_order,
  email
}: ApiCommonParams & {
  id_order: string;
  email: string;
}): Promise<IProfileOrder> => {
  const apiClient = getAPIClient({ country });

  const { data } = await apiClient.get<GuestOrderResponse>(
    '/wp-json/uyn/v1/guest/order',
    {
      headers: {
        ['UYN-BEARER']: token,
        ['UYN-LANGUAGE']: lang,
        ['UYN-COUNTRY']: country
      },
      params: {
        id_order,
        email: email.toLowerCase()
      }
    }
  );

  const { order } = data || {};
  if (!order) {
    throw new Error('Not found');
  }
  if (Array.isArray(order) && order.length > 0) {
    return order[0];
  }
  return order as IProfileOrder;
};

export const getGuestOrderReturn = async ({
  lang,
  country,
  token,
  id_order,
  email
}: ApiCommonParams & {
  id_order: string;
  email: string;
}): Promise<IProfileOrder> => {
  const apiClient = getAPIClient({ country });

  const { data } = await apiClient.get<GuestOrderResponse>(
    '/wp-json/uyn/v1/guest/order-return',
    {
      headers: {
        ['UYN-BEARER']: token,
        ['UYN-LANGUAGE']: lang,
        ['UYN-COUNTRY']: country
      },
      params: {
        id_order,
        email: email.toLowerCase()
      }
    }
  );

  const { order } = data || {};
  if (!order) {
    throw new Error('Not found');
  }
  if (Array.isArray(order) && order.length > 0) {
    return order[0];
  }
  return order as IProfileOrder;
};
